import {ChangeDetectorRef, Component, EventEmitter, Output} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {BooxSessionService, IStringAnyMap} from 'lib-boox';
import {CommonModule} from "@angular/common";
import {RouterModule} from "@angular/router";

@Component({
  selector: 'host-sign-in',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CommonModule, RouterModule],
  templateUrl: './sign-in.component.html',
  styleUrl: './sign-in.component.scss'
})
export class SignInComponent {
  public controlEmail: FormControl = new FormControl('', [Validators.required, Validators.email]);
  public controlPassword: FormControl = new FormControl('', [Validators.required]);
  public controlRemember: FormControl = new FormControl(true);

  public error: boolean = false;

  public signinForm: FormGroup;

  private _sending: boolean = false;

  @Output('success') public success: EventEmitter<void> = new EventEmitter<void>();
  @Output('failed') public failed: EventEmitter<IStringAnyMap> = new EventEmitter<IStringAnyMap>();

  constructor(
    public session: BooxSessionService,
    private cdr: ChangeDetectorRef, // For manual change detection
  ) {
    this.signinForm = new FormGroup({
      email: this.controlEmail,
      password: this.controlPassword,
      remember: this.controlRemember,
    });
  }

  send() {
    if (this.signinForm.invalid) return;
    let credentials = this.signinForm.value;
    this._sending = true;
    this.session.signIn(credentials).subscribe({
      next: () => {
        this.success.emit();
        this._sending = false;
      },
      error: (error) => {
        this.failed.emit(error);
        this._sending = false;
        this.error = true;

        setTimeout(() => {
          this.error = false;
          this.cdr.markForCheck();
        }, 1000);
      },
    });
  }

  get disabled() {
    return this.signinForm.invalid || this._sending;
  }
}
